import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import { useToast } from "contexts/toast/toast.context";
import { oneTimeAuth } from "api/client/one-time-auth";

export const useOneTimeLogin = () => {
  const navigate = useNavigate();
  const { addFailureToast, addSuccessToast } = useToast();
  const [searchParams] = useSearchParams();
  const appointmentId = searchParams.get("appointmentId");
  const tab = searchParams.get("tab");

  const { mutate } = useMutation({
    mutationFn: (token: string) => oneTimeAuth(token),
    onSuccess: (result) => {
      if (appointmentId) {
        const newSearchParams = new URLSearchParams();
        newSearchParams.set("appointmentId", appointmentId);
        if (tab) newSearchParams.set("tab", tab);

        navigate(`/login?${newSearchParams.toString()}`, { state: { phone: result.phone } });
      } else {
        navigate("/login", { state: { phone: result.phone } });
      }
      addSuccessToast("Użyj hasła jednorazowego wysłanego na Twój numer telefonu");
    },
    onError: (err) => {
      const message = isAxiosError(err)
        ? err.response?.data?.message || err.message
        : (err as Error).message;
      addFailureToast(message || "Wystąpił niespodziewany błąd.");
    },
  });

  const onOneTimeAuth = ({ token }: { token: string }) => {
    mutate(token);
  };

  return {
    onOneTimeAuth
  };
};
